<template>
  <div>
    <v-img  src="@/assets/Header/header_logo.png"  v-on:click="tohome" class="imglog v-btn hidden-sm-and-down"></v-img>
  </div>
</template>
<script>
export default {
  methods: {
    tohome() {
      return this.$router.push("/");
    }
  }
};
</script>
